<script setup>
import { ref, shallowRef, onMounted, defineAsyncComponent } from 'vue';
import formVersionList from '@/components/clients/rsvp/components/form/versions';
import { useRsvpStore } from '@/stores/rsvp/rsvp.store';

const rsvpStore = useRsvpStore();

const Version = shallowRef(null);
const componentLoaded = ref(false);

function pickVersion() {
  if (formVersionList[rsvpStore.clientData.common.formVersion]) {
    Version.value = defineAsyncComponent(
      () =>
        import(
          `../versions/${
            formVersionList[rsvpStore.clientData.common.formVersion]
          }/types/GuestForm.vue`
        ),
    );
    componentLoaded.value = true;
  }
}

onMounted(() => {
  pickVersion();
});
</script>

<template>
  <Version v-if="componentLoaded" />
</template>
